import { useManagedRefs } from '../hooks/ref/useManagedRefs';
import { Overlay } from './overlay.component';
import css from './overlay.module.less';
import { overlayService } from './overlay.service';
import c from 'classnames';
import { useStore } from 'cross-state/react';
import { useMemo } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

export function OverlayContainer() {
    const overlays = useStore(overlayService.openOverlays);
    const containerClassNames = overlays.map((o) => o.containerClassName).filter(Boolean);
    const zIndex = overlays[0]?.zIndex === 'above-menu' ? 1601 : (overlays[0]?.zIndex ?? 1300);

    const overlayGuids = useMemo(() => new Set(overlays.map((overlay) => overlay.guid)), [overlays]);
    const refs = useManagedRefs<HTMLDivElement>(overlayGuids, {
        enableProxyFallback: true,
    });

    return (
        <TransitionGroup
            className={c(css.overlayContainer, ...containerClassNames)}
            data-testid="overlayContainer"
            css={{
                zIndex,
            }}
        >
            {overlays.map((overlay) => (
                <CSSTransition
                    key={overlay.guid}
                    classNames={{ ...css, ...overlay.animationClassNames }}
                    timeout={300}
                    nodeRef={refs[overlay.guid]}
                >
                    <Overlay {...overlay} modalRef={refs[overlay.guid]} />
                </CSSTransition>
            ))}
        </TransitionGroup>
    );
}
